// Shared constants reused across every TTK/reward formula in the design doc
// -- don't reinvent these per-system (see CLAUDE.md).

// Every attack roll (player and every enemy, symmetrically) has two
// independent variance layers (16.14): a flat hit chance, and -- on a hit --
// a uniform damage multiplier.
export const HIT_CHANCE = 0.9;
export const DAMAGE_VARIANCE_MIN = 0.5;
export const DAMAGE_VARIANCE_MAX = 1.49;

// 90% hit chance x uniform 0.50-1.49x damage variance = 0.895 (16.12/16.14).
// Realized damage converges to raw DPS x EFF over enough ticks (16.30).
export const EFF = 0.895;

// Range-based hit-chance curves per Hardpoint weapon type (16.66, extends
// 16.14) -- ceil at point-blank, floor at max range, replacing the flat
// HIT_CHANCE above for any fire roll where a real distance/range pair is
// known (the live Expedition View; combatResolutionLoop's own abstracted
// tick() has no positions, so it keeps using flat HIT_CHANCE). Each curve
// is centered on the same 0.90 average as before so 16.12's locked TTK
// numbers stay valid without re-simulation -- only the *spread* differs:
// Auto-Turret (600m, close) stays tight/consistent since its whole band is
// short range; Laser Turret (1400m, medium) swings widest; Missile Turret
// (3000m, long) is deliberately the narrowest spread, mirroring EVE's real
// turret-vs-missile consistency asymmetry.
export interface HitChanceCurve {
  ceil: number;
  floor: number;
}
export const HIT_CHANCE_CURVES: Record<"auto" | "laser" | "missile", HitChanceCurve> = {
  auto: { ceil: 0.95, floor: 0.85 },
  laser: { ceil: 1.0, floor: 0.8 },
  missile: { ceil: 0.92, floor: 0.88 }
};

// Recovery gap between Wave-encounter stages: zero incoming damage, but
// wall-clock time still passes (16.12/16.30).
export const WAVE_GAP_SECONDS = 15;
